import { useFetch } from "./api";

export interface PricingOrg {
  id: number;
  status: string;
  supply_target_program: string | null;
}

export const usePricingOrg = () => {
  const { data, isLoading: isPricingOrgLoading } = useFetch<{ count: number; results: PricingOrg[] }>(
    ["pricing/settings"],
    "/pricing/settings",
    {},
    {
      select: (d) => d.data,
    },
  );
  const pricingOrg = data;

  return {
    pricingOrg: pricingOrg && pricingOrg.results.length > 0 ? pricingOrg.results[0] : null,
    isPricingOrgLoading: isPricingOrgLoading,
  };
};
